const layout = [
  {
    id: "occupied",
    name: "Occupied",
    colorBg: "bg-sky-400",
    colorTxt: "text-sky-700",
    colorChart: "oklch(74.6% 0.16 232.661)",
    message:
      "This room is located on the first floor and has a view of the garden.",
  },
  {
    id: "to_sell",
    name: "Rooms to Sell",
    colorBg: "bg-emerald-300",
    colorTxt: "text-emerald-700",
    colorChart: "oklch(84.5% 0.143 164.978)",
    message: "This room is available for check-out on January 2nd.",
  },
  {
    id: "out_of_order",
    name: "Out of Order",
    colorBg: "bg-neutral-400",
    colorTxt: "text-rose-700",
    colorChart: "oklch(70.8% 0 0)",
    message: "This room is available for check-in on January 1st.",
  },
];

const endDay = [
  {
    id: "occupied",
    name: "Occupied",
    colorBg: "bg-sky-400",
    colorTxt: "text-sky-700",
    colorChart: "oklch(74.6% 0.16 232.661)",
    message:
      "This room is located on the first floor and has a view of the garden.",
  },
  {
    id: "rooms_to_sell",
    name: "Rooms to Sell",
    colorBg: "bg-emerald-300",
    colorTxt: "text-emerald-700",
    colorChart: "oklch(84.5% 0.143 164.978)",
    message: "This room is available for check-out on January 2nd.",
  },
  {
    id: "out_of_order",
    name: "Out of Order",
    colorBg: "bg-neutral-400",
    colorTxt: "text-rose-700",
    colorChart: "oklch(70.8% 0 0)",
    message: "This room is available for check-in on January 1st.",
  },
];

const previousDay = [
  {
    id: "occupied",
    name: "Occupied",
    colorBg: "bg-sky-400",
    colorTxt: "text-sky-700",
    colorChart: "oklch(74.6% 0.16 232.661)",
    message:
      "This room is located on the first floor and has a view of the garden.",
  },
  {
    id: "rooms_to_sell",
    name: "Rooms to Sell",
    colorBg: "bg-emerald-300",
    colorTxt: "text-emerald-700",
    colorChart: "oklch(84.5% 0.143 164.978)",
    message: "This room is available for check-out on January 2nd.",
  },
  {
    id: "out_of_order",
    name: "Out of Order",
    colorBg: "bg-neutral-400",
    colorTxt: "text-rose-700",
    colorChart: "oklch(70.8% 0 0)",
    message: "This room is available for check-in on January 1st.",
  },
];

const guests = {
  adults: {
    name: "Adults",
    message: "This guest has made multiple bookings with us in the past.",
    colorBg: "bg-lime-400",
    colorTxt: "text-lime-700",
  },
  children: {
    name: "Children",
    message: "This guest has called us multiple times to make reservations.",
    colorBg: "bg-rose-400",
    colorTxt: "text-rose-700",
  },
};

export { layout, guests, endDay, previousDay };
